import React, { FunctionComponent } from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  subHeading: {
    fontSize: '24px',
    margin: 0,
    color: '#1E2864',
    letterSpacing: '0',
    fontWeight: 200,
    marginTop: '20px',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: '18px',
    },
  },
}))

type Props = {
  children?: React.ReactNode
  extraClasses?: string[]
}

const SubHeading: FunctionComponent<Props> = ({ children, extraClasses }) => {
  const classes = useStyles()

  const classList = [...(extraClasses || []), classes.subHeading].join(' ')

  return <h1 className={classList}>{children}</h1>
}

export { SubHeading }
